import axios from 'axios';

const API = axios.create({ 
  baseURL: import.meta.env.VITE_API_URL || 'https://atelier-erp-production-59ff.up.railway.app'
});

// Attach auth token + tenant headers on every request.
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('erp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const companyId = localStorage.getItem('erp_company_id');
  const fyId = localStorage.getItem('erp_fy_id');
  if (companyId) config.headers['x-company-id'] = companyId;
  if (fyId) config.headers['x-fin-year-id'] = fyId;
  return config;
});

/**
 * Forget who was signed in here.
 *
 * Every key the app keeps is named `erp_…`, so clearing the lot is the one
 * way that cannot fall behind: a key added later is covered the day it is
 * added. That matters most for a supervisor's step-in, which keeps their own
 * token on the machine — left behind, the next person to sign in on this
 * browser could step back into the supervisor's session.
 */
// How this browser likes to look. Not whose session it is, so it stays.
const KEPT = new Set(['erp_theme', 'erp_portal_layout']);

export function clearSession() {
  try {
    for (const k of Object.keys(localStorage)) {
      if (k.startsWith('erp_') && !KEPT.has(k)) localStorage.removeItem(k);
    }
  } catch { /* storage can be shut off; there is nothing to clear then */ }
}

// On 401 clear session.
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearSession();
      if (!window.location.pathname.startsWith('/login')) window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

export const apiGet = async (url, params) => (await API.get(url, { params })).data;
export const apiPost = async (url, body) => (await API.post(url, body)).data;
export const apiPut = async (url, body) => (await API.put(url, body)).data;
export const apiPatch = async (url, body) => (await API.patch(url, body)).data;
export const apiDelete = async (url) => (await API.delete(url)).data;

export default API;